import * as svg from "../../../assets/magnet-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const MagnetIcon = iconBuilder(svg, "MagnetIcon", "0 0 20 21");
